<app-maintenance-banner></app-maintenance-banner>
<div *ngIf="showFullLayout && (isAuthenticated$ | async)">
  <app-top-navigation></app-top-navigation>
  <div class="main-container" [class.shrink]="isShrunk">
    <app-sidebar (shrink)="toggleShrink($event)"></app-sidebar>
    <div class="main-content">
      <app-breadcrumb></app-breadcrumb>
      <div *ngIf="!networkService.isOnline" class="offline-banner">
        ⚠️{{ 'ERROR_MESSAGES.OFFLINE_ERROR_MESSAGE' | translate }}
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div *ngIf="!showFullLayout">
  <router-outlet></router-outlet>
</div>
<!-- Always place modal/dialog at the root level -->
<app-session-expired-dialog
  *ngIf="sessionExpired"
  [signInInProgress]="signInInProgressElsewhere"
  (confirm)="onDialogClose()"
>
</app-session-expired-dialog>
<app-session-warning-dialog
  *ngIf="sessionWarningVisible"
  [secondsRemaining]="sessionWarningSecondsRemaining"
  (stayLoggedIn)="onSessionStayLoggedIn()"
  (dismiss)="onSessionWarningDismiss()"
>
</app-session-warning-dialog>
<!-- SYRC-7180: PC deletion progress toast, survives navigation and reloads. -->
<app-pc-deletion-toast></app-pc-deletion-toast>
<!-- SYRC-7544: large asset-import progress pop-up, survives navigation and reloads. -->
<app-import-progress-popup></app-import-progress-popup>
